<a (click)="setPage()">{{message}}</a>